<template>
  <button
    class="w-100 aos-button d-flex fw-bold rounded-pill color-sachlich-white justify-content-center"
    :class="buttonColorClass"
    :disabled="!active"
    @click.stop="clicked"
  >
    <div
      v-if="textPosition === 'left'"
      class="px-2 text-center rounded-end-pill"
    >
      {{ text }}
    </div>
    <div
      class="button-price px-2 text-end"
      :class="textPosition === 'left' ? 'border-left rounded-end-pill' : 'border-right rounded-start-pill'"
    >
      <Price 
        :amount="price" 
        :cents="cents"
      />
    </div>
    <div
      v-if="textPosition === 'right'"
      class="px-2 text-center rounded-end-pill"
    >
      {{ text }}
    </div>
  </button>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { ClickCallback } from '../callbacks';
import Price from './Price.vue';

export default defineComponent({
  components: { Price },

  props: {
    active: { type: Boolean, default: true },
    price: { type: Number, default: undefined },
    cents: { type: Boolean, default: false },
    text: { type: String, default: 'weiter' },
    textPosition: {
      type: String as PropType<'left' | 'right'>,
      default: 'right',
    },
    buttonColor: {
      type: String as PropType<'expi-blue' | 'green' | 'red'>,
      default: 'expi-blue',
      required: false
    },
    clicked: { type: Function as PropType<ClickCallback>, default: () => console.log('clicked function not implemented') }, // eslint-disable-line no-console
  },

  computed: {
    buttonColorClass() {
      switch (this.buttonColor) {
        case 'red':
          return 'aos-button-theme-red';
        case 'green':
          return 'aos-button-theme-green';
        default:
          return 'aos-button-theme-expi-blue';
      }
    },
  },
})
</script>

<style scoped lang="scss">
@import "@gecko-akh/shared-styles/src/styles/AOS.vars.scss";
@import "@gecko-akh/shared-styles/src/styles/vars.scss";

.aos-button {
  height: 32px;
  border: 2px solid var(--color-border);
  background-color: var(--color-background);

  &:hover {
    background-color: var(--color-background-hover);
    border-color: var(--color-border-hover);
  }

  &:active {
    background-color: $color-pressed-blue;
    border-color: $color-pressed-blue;
  }

  &:focus-visible::after {
    border-radius: $radius-rounded;
    inset: px-to-rem(-4px);
  }
}

.aos-button[disabled] {
  background-color: $color-aida-gray;
  border-color: $color-aida-border;
  opacity: 1;
  pointer-events: none;
}

.border-right {
  border-right: 2px solid $color-aida-white;
}

.border-left {
  border-left: 2px solid $color-aida-white;
}

.aos-button-theme-default {
  --color-border: #{$color-aida-blue};
  --color-border-hover: #{$color-aida-blue-h};
  --color-background: #{$color-aida-blue};
  --color-background-hover: #{$color-aida-blue-h};
}

.aos-button-theme-expi-blue {
  --color-border: #{$color-expinet-blue};
  --color-border-hover: #{$color-expinet-blue-h};
  --color-background: #{$color-expinet-blue};
  --color-background-hover: #{$color-expinet-blue-h};
}

.aos-button-theme-green {
  --color-border: #{$color-aida-green};
  --color-border-hover: #{$color-aida-green-h};
  --color-background: #{$color-aida-green};
  --color-background-hover: #{$color-aida-green-h};
}

.aos-button-theme-red {
  --color-border: #{$color-aida-red};
  --color-border-hover: #{$color-aida-red-h};
  --color-background: #{$color-aida-red};
  --color-background-hover: #{$color-aida-red-h};
}
</style>
